var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"buttons__item",style:({
    'background-color': _vm.backgroundColor,
    color: _vm.fontColor,
    'border-color': _vm.borderColor,
    'font-size': _vm.fontSize,
    padding: _vm.padding,
    height: _vm.height,
    'line-height': _vm.lineHeight ? _vm.lineHeight : _vm.fontSize,
    width: _vm.width,
  }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }